import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

export interface SelectOption {
  label: string;
  value: string;
}

@Component({
  selector: 'tf-select-input',
  standalone: true,
  imports: [FormsModule, SelectModule],
  template: `
    <p-select
      [inputId]="inputId()"
      [options]="options()"
      optionLabel="label"
      optionValue="value"
      [placeholder]="placeholder()"
      [ngModel]="modelValue()"
      (ngModelChange)="valueChange.emit($event)"
      [invalid]="invalid()"
      [showClear]="showClear()"
      [emptyMessage]="emptyMessage()"
      appendTo="body"
      class="w-full"
    />
  `,
  styles: ':host { display: block; width: 100%; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectInputComponent {
  readonly value = input<string | null>(null);
  /**
   * Value bound to the PrimeNG select. Empty string is coerced to `null` so the control reads
   * as "nothing selected" — otherwise PrimeNG treats `''` as filled and renders the clear (X)
   * icon in the initial empty state (TF-1925).
   */
  readonly modelValue = computed<string | null>(() => {
    const v = this.value();
    return v === '' ? null : v;
  });
  readonly options = input<SelectOption[]>([]);
  readonly placeholder = input<string>('');
  readonly inputId = input<string>('tf-select-input');
  readonly invalid = input<boolean>(false);
  readonly showClear = input<boolean>(false);
  readonly emptyMessage = input<string>('');
  @Output() readonly valueChange = new EventEmitter<string>();
}
